/* eslint-disable */
console.log(`Mode => ${process.env.REACT_APP_MODE}`);
const ServerConstants = {
  SERVER_URL: process.env.REACT_APP_BACKEND_API_PRIVATE_BASE_URL,
};

export const ENVIRONMENT = process.env.REACT_APP_MODE;
export const IS_PRODUCTION = ENVIRONMENT === 'prod'
export const envPrefix = IS_PRODUCTION ? 'live_' : 'test_';
export const SECRET_ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

console.log(`ENVIRONMENT => ${ENVIRONMENT}`, process.env.TYPE, process.env.REACT_APP_TYPE);

export default ServerConstants;
